<template>
  <v-col cols="12">
    <v-slide-group v-model="slide" show-arrows>
      <v-slide-item
        v-for="(item, i) in coreCard.users"
        class="my-4 mx-3"
        :key="i"
      >
        <v-badge color="success" :content="item.value + 'x'" overlap>
          <user-avatar
            :size="55"
            :user="item"
            cssClass="text-h5"
            :toolTipText="item.fullName"
          >
          </user-avatar>
        </v-badge>
      </v-slide-item>
    </v-slide-group>
  </v-col>
</template>

<script>
export default {
  name: "CoreCardUsers",
  props: {
    coreCard: { type: Object },
    formatValue: { type: Boolean, default: false }
  },
  watch: {},
  data: () => ({
    slide: null
  }),
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
::v-deep .v-slide-group__next,
::v-deep .v-slide-group__prev {
  min-width: inherit;
}
</style>
